module.exports = __webpack_public_path__ + "static/sinkopere-0eefd0881dd898c5815e6c9fda32c62f.png";